import { render } from "./DateRenderer.vue?vue&type=template&id=7646da00"
import script from "./DateRenderer.vue?vue&type=script&lang=js"
export * from "./DateRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__